import type { Timestamp } from 'firebase/firestore';

export type MessageChannel = 'whatsapp' | 'instagram' | 'facebook';

export interface ChannelMessage {
  id: string;
  channel: MessageChannel;
  direction: 'inbound' | 'outbound';
  contactPhone: string | null;
  contactHandle?: string | null;
  contactName?: string | null;
  fromName?: string | null;
  from?: string | null;
  to?: string | null;
  text: string | null;
  type: string;
  templateName?: string | null;
  templateLanguage?: string | null;
  templateComponents?: any[];
  templateButtons?: string[];
  status: string;
  waMessageId?: string | null;
  senderId?: string | null;
  senderPhoneNumberId?: string | null;
  senderName?: string | null;
  leadId?: string | null;
  projectId?: string | null;
  bookingId?: string | null;
  mediaInfo?: Record<string, unknown> | null;
  rawMessagePayload?: Record<string, unknown> | null;
  providerPayload?: Record<string, unknown> | null;
  payload?: Record<string, unknown> | null;
  providerResponse?: Record<string, unknown> | null;
  statusPayload?: Record<string, unknown> | null;
  readAt?: Timestamp | null;
  createdAt?: Timestamp | null;
  sentAt?: Timestamp | null;
  receivedAt?: Timestamp | null;
  updatedAt?: Timestamp | null;
  metadata?: Record<string, unknown>;
}

export interface Conversation {
  contactId: string;
  channel: MessageChannel;
  contactPhone: string | null;
  contactName: string | null;
  contactDisplay: string;
  lastMessage: ChannelMessage;
  lastMessageAt: Date;
  unreadCount: number;
  leadId?: string | null;
  leadName?: string | null;
  brokerId?: string | null;
  brokerName?: string | null;
  brokerAgencyName?: string | null;
  customerUnitId?: string | null;
  customerUnitNumber?: string | null;
  customerProjectId?: string | null;
  customerProjectName?: string | null;
  customerName?: string | null;
  customerLinkedUnits?: Array<{ projectId: string; projectName: string; unitId: string; unitNumber: string }>;
}

export interface ChannelConfig {
  key: MessageChannel;
  label: string;
  color: string;
  outboundBubbleColor: string;
  sendFn: string;
  collection: string;
  comingSoon?: boolean;
}

export const CHANNEL_CONFIGS: Record<MessageChannel, ChannelConfig> = {
  whatsapp: {
    key: 'whatsapp',
    label: 'WhatsApp',
    color: '#25d366',
    outboundBubbleColor: '#dcf8c6',
    sendFn: 'whatsappSendMessage',
    collection: 'whatsappMessages',
  },
  instagram: {
    key: 'instagram',
    label: 'Instagram',
    color: '#E1306C',
    outboundBubbleColor: '#ffe0ec',
    sendFn: 'instagramSendMessage',
    collection: 'instagramMessages',
    comingSoon: true,
  },
  facebook: {
    key: 'facebook',
    label: 'Facebook',
    color: '#1877F2',
    outboundBubbleColor: '#d9e8fb',
    sendFn: 'facebookSendMessage',
    collection: 'facebookMessages',
    comingSoon: true,
  },
};
